import { object, boolean, array, string, number } from 'yup';
import { HAS_CONFIRMED_DANGEROUS_GOODS, SELECTED_PRODUCTS } from '../constants';
import { messages } from './messages';
import { ShipStationFulfillmentBarcode } from '../../../../../../../products/product-details/constants/product-options';

const productSchema = object({
  productId: string().required(),
  productOptions: object({
    [ShipStationFulfillmentBarcode]: string().required(),
  }).required(),
  sku: string().required(),
  dangerousGoods: array().nullable(),
  name: string(),
  parentProductId: string().nullable(),
  quantity: number().positive().required(),
  thumbnailUrl: string().nullable(),
  unitPrice: object(),
});

export const ProductConfigurationsSchema = object({
  [SELECTED_PRODUCTS]: array(productSchema).ensure(),
  [HAS_CONFIRMED_DANGEROUS_GOODS]: boolean().required(messages.required).oneOf([true], messages.required),
  isComplete: boolean(),
});
